import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news19_1 from "../../images/news/news19_1.jpg";
import news19_2 from "../../images/news/news19_2.jpg";
import news19_3 from "../../images/news/news19_3.jpg";
import news19_4 from "../../images/news/news19_4.jpg";
import news19_5 from "../../images/news/news19_5.jpg";
import news19_6 from "../../images/news/news19_6.jpg";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news19 extends Component {
    componentDidMount() {}

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News19_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News19_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News19_LinkHome")}</Link>
                                </li>
                                <li>{t("News19_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News19_Content_H")}</h1>

                                            {/* P1 */}
                                            <ReactMarkdown>{t("News19_P1_MD")}</ReactMarkdown>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news19_1}
                                                    alt={t("News19_IMG1_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News19_IMG1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News19_P2_MD")}</ReactMarkdown>

                                            {/* IMG 2 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news19_2}
                                                    alt={t("News19_IMG2_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News19_IMG2_DESC")}
                                                </div>
                                            </div>

                                            {/* P3 */}
                                            <ReactMarkdown>{t("News19_P3_MD")}</ReactMarkdown>

                                            {/* IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news19_3}
                                                    alt={t("News19_IMG3_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News19_IMG3_DESC")}
                                                </div>
                                            </div>

                                            {/* P4 */}
                                            <ReactMarkdown>{t("News19_P4_MD")}</ReactMarkdown>

                                            {/* IMG 4 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news19_4}
                                                    alt={t("News19_IMG4_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News19_IMG4_DESC")}
                                                </div>
                                            </div>

                                            {/* P5 */}
                                            <ReactMarkdown>{t("News19_P5_MD")}</ReactMarkdown>

                                            {/* IMG 5 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news19_5}
                                                    alt={t("News19_IMG5_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News19_IMG5_DESC")}
                                                </div>
                                            </div>

                                            {/* P6 */}
                                            <ReactMarkdown>{t("News19_P6_MD")}</ReactMarkdown>

                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news19_6}
                                                    alt={t("News19_IMG6_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News19_IMG6_DESC")}
                                                </div>
                                            </div>

                                            {/* P7 */}
                                            <ReactMarkdown>{t("News19_P7_MD")}</ReactMarkdown>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

export default news19 = withTranslation()(news19);
